import { Controller } from '@hotwired/stimulus';
import { parseFormattedNumber } from '../utils/parse_formatted_number';

export default class NumberFormatController extends Controller {
  static targets = ['input'];
  static values = {
    locale: String,
  };

  connect() {
    this.formatter = new Intl.NumberFormat(this.localeValue || 'hu-HU', { useGrouping: true });
  }

  onKeydown(e) {
    if (e.key !== 'Backspace') {
      return;
    }

    const input = this.inputTarget;
    const pos = input.selectionStart;

    if (pos !== input.selectionEnd || pos < 2) {
      return;
    }

    const charBefore = input.value[pos - 1];
    if (/\d/.test(charBefore)) {
      return;
    }

    e.preventDefault();
    this.skipOverSeparator(input, pos);
  }

  skipOverSeparator(input, pos) {
    input.value = input.value.slice(0, pos - 2) + input.value.slice(pos - 1);
    input.setSelectionRange(pos - 2, pos - 2);
    this.onInput();
  }

  onInput() {
    const input = this.inputTarget;
    const oldValue = input.value;
    const oldPos = input.selectionStart;
    const rawOldValue = parseFormattedNumber(oldValue);

    if (!rawOldValue) {
      input.value = '';
      return;
    }

    const newValue = this.formatter.format(+rawOldValue);
    input.value = newValue;

    const diff = newValue.length - oldValue.length;
    const newPos = Math.max(0, oldPos + diff);

    input.setSelectionRange(newPos, newPos);
  }
}
